/**
 * LocalizedDateProvider - Wraps MUI LocalizationProvider with dynamic locale.
 * Uses useLanguage() to automatically switch DayJS and MUI locales.
 *
 * Must be rendered inside LanguageProvider.
 */

import { ReactNode } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useLanguage } from "@/providers/LanguageProvider";
import { DAYJS_LOCALE_MAP, getMuiLocaleText } from "@/constants/date-locales";

interface LocalizedDateProviderProps {
  children: ReactNode;
}

export const LocalizedDateProvider = ({ children }: LocalizedDateProviderProps) => {
  const { currentLanguage } = useLanguage();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={DAYJS_LOCALE_MAP[currentLanguage]} localeText={getMuiLocaleText(currentLanguage)}>
      {children}
    </LocalizationProvider>
  );
};
